import React from 'react';
import './RedirectOverlay.css';

/**
 * RedirectOverlay - Reusable component for showing beautiful loading screens during redirects
 * 
 * @param {boolean} show - Whether to show the overlay
 * @param {string} userName - User's name for personalized message
 * @param {string} message - Custom status message (optional)
 * @param {string} title - Custom title (optional, defaults to "Autentificare Reușită!")
 */
const RedirectOverlay = ({
    show = false,
    userName = 'utilizator',
    message = 'Vă redirecționăm...',
    title = 'Autentificare Reușită!',
    type = 'success' // 'success' or 'loading'
}) => {
    if (!show) return null;

    return (
        <div className="redirect-overlay">
            <div className="redirect-content">
                {type === 'success' ? (
                    <>
                        <div className="success-animation">
                            <div className="checkmark-circle">
                                <div className="checkmark"></div>
                            </div>
                        </div>
                        <h2 className="redirect-title">{title}</h2>
                        <p className="redirect-message">
                            Bun venit, {userName}!
                        </p>
                    </>
                ) : (
                    <>
                        <div className="loading-animation">
                            <div className="loading-circle">
                                <div className="loading-spinner-large"></div>
                            </div>
                        </div>
                        <h2 className="redirect-title">Autentificare în curs...</h2>
                        <p className="redirect-message">
                            Vă conectăm la sistemul medical...
                        </p>
                    </>
                )}

                <div className="loading-spinner">
                    <div className="spinner"></div>
                </div>
                <p className="redirect-status">{message}</p>
                <div className="progress-bar">
                    <div className="progress-fill"></div>
                </div>
            </div>
        </div>
    );
};

export default RedirectOverlay;
